import { motion } from "framer-motion";
import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";

export default function Contacto() {
  return (
    <section
      id="contacto"
      className="py-20 md:py-32 bg-[#080f1c]"
      data-testid="contacto-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <span className="text-[#3DD9E8] text-sm font-bold uppercase tracking-[0.3em] font-body">
            Escribinos
          </span>
          <h2 className="font-heading text-4xl md:text-6xl text-white uppercase tracking-tight mt-3">
            Contacto
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20">
          {/* Info */}
          <motion.div
            className="space-y-8"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#3DD9E8]/30">
                <MapPin className="text-[#3DD9E8]" size={20} />
              </div>
              <div>
                <h4 className="font-heading text-lg text-white uppercase tracking-wide">Direccion</h4>
                <p className="text-gray-400 font-body text-sm mt-1">
                  Suipacha 3659, B1650<br />
                  Villa Juan Martin de Pueyrredon<br />
                  Provincia de Buenos Aires
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#3DD9E8]/30">
                <Phone className="text-[#3DD9E8]" size={20} />
              </div>
              <div>
                <h4 className="font-heading text-lg text-white uppercase tracking-wide">Telefono</h4>
                <a href="tel:01170780123" className="text-gray-400 hover:text-[#3DD9E8] font-body text-sm mt-1 block transition-colors duration-200">
                  011 7078-0123
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#3DD9E8]/30">
                <Mail className="text-[#3DD9E8]" size={20} />
              </div>
              <div>
                <h4 className="font-heading text-lg text-white uppercase tracking-wide">Email</h4>
                <a href="mailto:puertodeseadoviajes@gmail.com" className="text-gray-400 hover:text-[#3DD9E8] font-body text-sm mt-1 block transition-colors duration-200">
                  puertodeseadoviajes@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#25D366]/30 bg-[#25D366]/5">
                <MessageCircle className="text-[#25D366]" size={20} />
              </div>
              <div>
                <h4 className="font-heading text-lg text-white uppercase tracking-wide">WhatsApp</h4>
                <a href="https://wa.me/5491137631501" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#25D366] font-body text-sm mt-1 block transition-colors duration-200">
                  +54 9 11 3763-1501
                </a>
              </div>
            </div>
          </motion.div>

          {/* WhatsApp CTA */}
          <motion.div
            className="flex flex-col items-center justify-center text-center p-10 md:p-14 bg-[#151e32] border border-white/5"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <div className="w-20 h-20 flex items-center justify-center bg-[#25D366]/10 border border-[#25D366]/30 mb-6">
              <MessageCircle className="text-[#25D366]" size={40} />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wide mb-3">
              Contactanos por WhatsApp
            </h3>
            <p className="text-gray-400 font-body text-sm md:text-base mb-8 max-w-sm">
              Escribinos y te respondemos al instante. Consulta tu presupuesto sin compromiso.
            </p>
            <a
              href="https://wa.me/5491137631501?text=Hola%2C%20quiero%20consultar%20por%20un%20servicio%20de%20transporte"
              target="_blank"
              rel="noopener noreferrer"
              className="clip-slant bg-[#25D366] hover:bg-[#1fba59] text-white font-bold uppercase tracking-wider py-4 px-12 text-sm flex items-center gap-3 transition-colors duration-200"
              data-testid="whatsapp-cta-button"
            >
              <MessageCircle size={20} />
              Escribir por WhatsApp
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
